import Space from 'antd/lib/space'
import { AvatarSkeleton, InputSkeleton } from '../components/Skeletons'

const skeletonData = [
  { width: '70%' },
  { width: '80%' },
  { width: '65%' },
  { width: '85%' },
  { width: '82%' }
]

export const FilteredJobsSkeleton = () => {
  return (
    <div className="flex flex-col">
      <Space>
        <AvatarSkeleton height="27px" width="26px" />
        <InputSkeleton height="15px" />
      </Space>
      <InputSkeleton size="large" height="25px" width="50%" className="mt-[21px]" />
      {skeletonData.map((item, index) => (
        <div key={index}>
          <InputSkeleton
            size="small"
            active={true}
            height="10px"
            width={item.width}
            className="mt-[4px]"
            uniqKey={index}
          />
        </div>
      ))}
    </div>
  )
}
